/**
 * StatsCard - Reusable stats card component for dashboard
 */
import { Card, CardContent } from '@/components/ui/card';

const StatsCard = ({ icon: Icon, value, label, iconBgColor = "bg-blue-100", iconColor = "text-blue-600" }) => {
  return (
    <Card>
      <CardContent className="p-4 sm:pt-6 sm:p-6">
        <div className="flex flex-col items-center text-center gap-2">
          <div className={`p-3 ${iconBgColor} rounded-xl`}>
            <Icon className={`w-6 h-6 sm:w-7 sm:h-7 ${iconColor}`} />
          </div>
          <div>
            <p className="text-xl sm:text-2xl font-bold">{value}</p>
            <p className="text-xs sm:text-sm text-gray-600">{label}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
